import { createSelector } from "@reduxjs/toolkit";

export const singleDashboardState = (state) => state.singleDashboard;

export const singleDashboardSelector = createSelector(singleDashboardState, (state) => state);
